import { useTranslation } from 'react-i18next';

const locations = [
  {
    area: 'Yaiza, Lanzarote',
    villasKey: 'villa_buenlugar_tagline',
    description:
      'A quiet village setting in the south of the island, surrounded by dramatic volcanic landscapes and just a short drive from golden beaches.',
    mapUrl:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d55875.236789123!2d-13.7955!3d28.9523!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xc4623b4e5e5e5e5%3A0x5e5e5e5e5e5e5e5e!2sYaiza%2C+Lanzarote!5e0!3m2!1ses!2ses!4v1690000000000!5m2!1ses!2ses',
    mapTitle: 'Villas Yaiza - Yaiza, Lanzarote location',
    nearbyPlaces: [
      { name: 'Femés', distance: '4.7 km' },
      { name: 'Playa de Janubio', distance: '6.8 km' },
      { name: 'Cortijo Viejo', distance: '6.8 km' },
      { name: 'Quemada Beach', distance: '7.7 km' },
      { name: 'Playa del Paso', distance: '7.9 km' },
      { name: 'Mácher', distance: '8.0 km' },
    ],
  },
  {
    area: 'El Golfo, Lanzarote',
    villasKey: 'villa_golfo_tagline',
    description:
      'A picturesque coastal village on the west coast, famous for the green lagoon, volcanic coves and unforgettable sunsets over the Atlantic.',
    mapUrl:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27920.13821913668!2d-13.8301!3d28.9852!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xc4625a5a5a5a5a5%3A0x5a5a5a5a5a5a5a5a!2sEl%20Golfo%2C%20Lanzarote!5e0!3m2!1ses!2ses!4v1690000000000!5m2!1ses!2ses',
    mapTitle: 'Villas Yaiza - El Golfo, Lanzarote location',
    nearbyPlaces: [
      { name: 'Charco Verde', distance: '0.5 km' },
      { name: 'El Golfo Beach', distance: '0.6 km' },
      { name: 'Los Hervideros', distance: '2.9 km' },
      { name: 'Timanfaya National Park', distance: '6.8 km' },
      { name: 'Playa Blanca', distance: '13.7 km' },
      { name: 'Yaiza Village', distance: '9.3 km' },
    ],
  },
];

export default function MapSection() {
  const { t } = useTranslation();

  return (
    <section id="location" className="py-16 md:py-24 px-4 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs md:text-sm uppercase tracking-[0.2em] text-foreground-500 font-medium mb-3">
            {t('map_subtitle')}
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950">
            {t('map_subtitle')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Our homes are spread across two beautiful corners of Lanzarote, each with its own unique character and charm.
          </p>
        </div>

        <div className="space-y-12 md:space-y-16">
          {locations.map((location) => (
            <div key={location.area}>
              <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-2 mb-6 md:mb-8">
                <div>
                  <h3 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
                    {location.area}
                  </h3>
                  <p className="mt-1 text-sm font-medium text-primary-600">{t(location.villasKey)}</p>
                </div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
                <div className="lg:col-span-2 rounded-lg overflow-hidden h-[300px] md:h-[400px]">
                  <iframe
                    src={location.mapUrl}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title={location.mapTitle}
                    className="rounded-lg"
                  ></iframe>
                </div>

                <div className="bg-background-50 rounded-lg p-5 md:p-6 flex flex-col">
                  <p className="text-sm text-foreground-600 mb-5">{location.description}</p>
                  <h4 className="font-heading text-base font-semibold text-foreground-950 mb-3">
                    {t('map_nearby')}
                  </h4>
                  <div className="flex-1">
                    {location.nearbyPlaces.map((place) => (
                      <div
                        key={place.name}
                        className="flex items-center justify-between py-3 border-b border-background-200 last:border-b-0"
                      >
                        <div className="flex items-center gap-3">
                          <span className="w-5 h-5 flex items-center justify-center text-primary-500">
                            <i className="ri-map-pin-line text-sm"></i>
                          </span>
                          <span className="text-sm text-foreground-700 font-medium whitespace-nowrap">{place.name}</span>
                        </div>
                        <span className="text-xs text-foreground-500 whitespace-nowrap">{place.distance}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}